import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';
import { PracticeTestButtonQuestionNavigation } from './PracticeTestButtonQuestionNavigation';
import { shadows } from '@doltech/ui/lib/figma/shadows';

interface BottomNavigationProps extends React.HTMLAttributes<HTMLDivElement> {
  onSubmitWithEvents?: () => void;
}

const Main = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 150px);
  align-items: center;
  padding: 8px 24px;
  box-shadow: ${shadows.topZIndex2};

  background-color: ${colorsV2.white100};

  .left-side {
    margin: 0 auto;
  }

  .right-side {
    justify-items: end;
  }
`;

export const PracticeTestBottomNavigation = observer((props: BottomNavigationProps) => {
  const { children, onSubmitWithEvents } = props;
  return (
    <Main>
      <div className="left-side">{children}</div>
      <div className="right-side">
        <PracticeTestButtonQuestionNavigation onSubmitWithEvents={onSubmitWithEvents} enableEvent />
      </div>
    </Main>
  );
});
